<template>
    <div class="advanced-filter">
        <el-badge :value="badgeValue" :hidden="!badgeValue" class="badge">
            <el-button @click="openFilterWindow">
                {{$t('train.advancedSettings')}}
            </el-button>
        </el-badge>

        <Drawer
            v-if="drew"
            :title="$t('train.advancedSettings')"
            styleWidth="300"
            :visible=drawerVisible
            :onClose=onCloseDrawer
        >
            <p style="margin-bottom: 10px;">{{$t('train.advancedAccount')}}</p>
            <el-input
                type="textarea"
                v-model="nameTxt"
                :autosize="{ minRows: 20, maxRows: 25}">
            </el-input>
            <p style="text-align: right">{{nameArr.length}} / 1000</p>

            <div class="btn-group">
                <el-button class="btn-reset" size="small" type="warning" @click="reset">{{$t('c.reset')}}</el-button>
                <el-button class="btn-save" size="small" type="primary" @click="onSave">{{$t('c.save')}}</el-button>
            </div>
        </Drawer>
    </div>
</template>

<script>
    import Drawer from '@/pages/MapManage/Drawer'

    export default {
        components: {
            Drawer
        },
        data() {
            return {
                drew: false,
                drawerVisible: false,
                nameTxt: '',
                badgeValue: 0,
            }
        },
        created() {

        },
        computed: {
            nameArr() {
                let arr = [];

                // 替换掉所有引号
                this.nameTxt = this.nameTxt.replace(/\'|\"|\“|\”|\”|\“/g, '')

                arr = this.nameTxt.split(/\s+/);
                arr = arr.filter(item => item.length > 0);

                return arr;
            }
        },
        methods: {
            onSave() {
                let result = this.nameArr;

                if (result.length > 1000) {
                    this.$message.error(this.$t('train.advancedMaxError'));
                    return
                }

                this.badgeValue = result.length;
                this.$emit('advancedChange', result);
                this.onCloseDrawer();
            },

            // 重置
            reset() {
                this.nameTxt = '';
                this.badgeValue = 0;
                this.$emit('advancedChange', []);
            },

            openFilterWindow() {
                this.drew = true;
                setTimeout(() => {
                    this.drawerVisible = true;
                }, 0)
            },
            onCloseDrawer() {
                this.drawerVisible = false;
                setTimeout(() => {
                    this.drew = false;
                }, 300)
            },
        },
        watch: {},
    }
</script>

<style lang="scss">

    .advanced-filter {

        .badge {
            margin-right: 10px;
        }

        textarea {
            max-height: 480px;
        }

        .btn-group {
            padding-top: 20px;
            text-align: center;

            button {
                margin: 0 0 20px 0;
                width: 55%;
            }
        }
    }
</style>
